<div class="betslip-edit-bet__summary">
    <bs-quick-deposit
        *ngIf="isQuickDepositOpen"
        [inColumn]="inColumn"
        [keepOpen]="keepDepositOpen"
        [trackingSource]="quickDepositSource"></bs-quick-deposit>
    <bs-quick-deposit-message></bs-quick-deposit-message>
    <div class="betslip-edit-bet__summary-separator" *ngIf="!isQuickDepositOpen">{{ siteCore.betslip.editBet.cashOutStakeInfo }}</div>
    <div class="betslip-edit-bet__summary-body">
        <div [hidden]="!this.numpadDisplayService.isOpen()">
            <div class="edit-bet-stake-numpad__item_header">
                <div class="edit-bet-stake-numpad__item_header_title">{{ siteCore.betslip.editBet.addStake }}</div>

                <div class="edit-bet-stake-numpad__item_header_close" *msShowInEpcot="{ showInEpcot: true }" (click)="cancelStake()">
                    {{ siteCore.globalMessages.Close }}
                </div>
                <div class="edit-bet-stake-numpad__item_header_close theme-ex" *msShowInEpcot="{ showInEpcot: false }" (click)="cancelStake()"></div>
            </div>
            <div class="edit-bet-stake-numpad__item_stake">
                <span class="edit-bet-stake-numpad__item_stake_title">{{ siteCore.betslip.editBet.increaseStakeBy }}</span>
                <div class="edit-bet-stake-numpad__item_stake_field">
                    <ms-stake
                        id="stakeComponent"
                        [showIncrementalStakes]="true"
                        [stake]="stake"
                        [keypadId]="'EMB_SUMMARY_NUMPAD'"
                        [errors]="hasStakeError$"
                        [numpadSource]="numpadSource"
                        (stakeChanged)="setStake($event)"
                        (stakeConfirm)="confirmStake()">
                    </ms-stake>
                </div>
            </div>
        </div>
        <ms-numpad-error *ngIf="!isQuickDepositOpen" [error]="stakeError$ | async"></ms-numpad-error>
        <div class="EMB-stake__numpad">
            <ms-numpad-host [id]="'EMB_SUMMARY_NUMPAD'"></ms-numpad-host>
        </div>
        <div class="betslip-edit-bet__summary-details" [ngClass]="{ 'summary-details-added-stake': !showAddStakeButton }">
            <div class="betslip-edit-bet__summary-stake" [ngClass]="{ 'summary-stake-added-stake': !showAddStakeButton }">
                <div class="betslip-edit-bet__summary-text">{{ siteCore.betslip.messages.Stake }}</div>
                <div class="betslip-edit-bet_summary_value-container">
                    <div class="betslip-edit-bet__summary-value__spinner" *ngIf="state.isEarlyPayoutStakeLoading"></div>
                    <div
                        class="betslip-edit-bet__summary-value"
                        *ngIf="!state.isEarlyPayoutStakeLoading"
                        [ngClass]="{ 'highlighted-value-below-min': isBelowMinStake }">
                        {{ earlyPayoutStake | bsCurrency: true }}
                    </div>
                </div>
            </div>

            <div class="betslip-edit-bet__summary-wrapped-content" *ngIf="!showAddStakeButton">
                <div class="betslip-edit-bet_summary_added-stake" [ngClass]="{ 'button-disabled': isDisabled }" (click)="addStake()">
                    <div>
                        <div class="betslip-edit-bet__summary-text highlighted-value">{{ siteCore.betslip.editBet.addedStake }}</div>
                        <div class="betslip-edit-bet_summary_value-container">
                            <div class="betslip-edit-bet__summary-value highlighted-value with-button-on-right">
                                <span>+ {{ state.addedStake | bsCurrency: true }}</span>
                                @if (!this.numpadDisplayService.isOpen()) {
                                    <button
                                        ds-button-icon
                                        kind="tertiary"
                                        variant="outline"
                                        size="small"
                                        class="stake-edited-icon-button"
                                        (click)="addStake()">
                                        <vn-icon class="betslip-icon" name="sports-edit-stake" size="10"></vn-icon>
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div class="betslip-edit-bet__summary-winnings">
                    <div class="betslip-edit-bet__summary-possibleWinning">
                        <div class="betslip-edit-bet__summary-text" (click)="openTaxationPopup()">
                            {{ possibleWinningsTitle }} <span class="theme-info" *ngIf="summary?.taxation"></span>
                        </div>
                    </div>
                    <div class="betslip-edit-bet__summary-value__spinner" *ngIf="state.isEarlyPayoutStakeLoading"></div>
                    <div class="betslip-edit-bet__summary-value" *ngIf="!state.isEarlyPayoutStakeLoading">
                        <span>{{ possibleWinningsNet | bsCurrency: true }}</span>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="showAddStakeButton">
                <button
                    ds-button
                    msThemedButton
                    kind="secondary"
                    variant="outline"
                    size="medium"
                    class="edit-stake-button"
                    [themeKind]="buttonThemeKind"
                    [disabled]="isDisabled"
                    (click)="addStake()">
                    <vn-icon slot="start" class="edit-stake-button-icon betslip-icon" size="12" name="theme-plus"></vn-icon>
                    {{ siteCore.betslip.editBet.addStake }}
                </button>
                <div class="betslip-edit-bet__summary-winnings withButton">
                    <div class="betslip-edit-bet__summary-possibleWinning">
                        <div class="betslip-edit-bet__summary-text" (click)="openTaxationPopup()">
                            {{ possibleWinningsTitle }} <span class="theme-info" *ngIf="summary?.taxation"></span>
                        </div>
                    </div>
                    <div class="betslip-edit-bet__summary-value__spinner" *ngIf="state.isEarlyPayoutStakeLoading"></div>
                    <div class="betslip-edit-bet__summary-value" *ngIf="!state.isEarlyPayoutStakeLoading">
                        <span>{{ possibleWinningsNet | bsCurrency: true }}</span>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="betslip-edit-bet__summary-column-info" *ngIf="applyColumnTaxation" [innerHTML]="interpolateTaxColumnSize()"></div>
        <bs-digital-taxation-info [vm]="buildTaxationPopupViewModel()" [(isVisible)]="isInfoVisible"></bs-digital-taxation-info>
        <bs-betslip-edit-bet-place-button></bs-betslip-edit-bet-place-button>
    </div>
</div>
